"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _flow = _interopRequireDefault(require("lodash/fp/flow"));

var _memoize = _interopRequireDefault(require("lodash/memoize"));

var _sortBy = _interopRequireDefault(require("lodash/fp/sortBy"));

var _toPairs = _interopRequireDefault(require("lodash/fp/toPairs"));

var _flat = require("flat");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this is the ideal API call.
// you may not like it but this is what peak performance looks like.
// lodash/memoize only looks at the first parameter by default.
// This looks at all of them.
var multiArgResolver = (0, _flow.default)(function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0, _flat.flatten)(args);
}, _toPairs.default, // ignore object key ordering
(0, _sortBy.default)('0'), _flat.unflatten, // if it's good enough for lodash's creator it's good enough for me
// https://github.com/lodash/lodash/issues/2115
JSON.stringify);
/**
 * Memoizes a function based on the _serializable_ equality of its arguments.
 * Useful for memoizing API calls.
 *
 * Utilizes `lodash/memoize`, which (by default) only memoizes based on the
 * first argument for the sake of performance.
 *
 * Usage:
 * ```js
 * const apiCall = (arg1, arg2, arg3) => axios.get('', { arg1, arg2, arg3 });
 *
 * const memoizedApiCall = memoize(apiCall);
 * ```
*/

var _default = function _default(func) {
  return (0, _memoize.default)(func, multiArgResolver);
};

exports.default = _default;
//# sourceMappingURL=index.js.map